'use strict';

var classChecks = require('../../common/var/classChecks');

var isArray = classChecks.isArray;

function isArrayOrInherited(obj) {
  return obj && obj.constructor && isArray(obj.constructor.prototype);
}

module.exports = isArrayOrInherited;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/internal/isArrayOrInherited.js
// module id = 402
// module chunks = 0